import { JsonAsset } from 'cc';
import Game from '../../../../Game';
import PathData from './PathData';
import { PathDataType, SpeedCurveDataType } from './PathDataType';

export default class BezierPathManager {
    private _pathMap: Map<string, PathData> = new Map();
    private _speedMap: Map<string, PathData> = new Map();

    constructor(private readonly _game: Game) {}

    public clearPath() {
        this._pathMap.clear();
    }

    public clearSpeed() {
        this._speedMap.clear();
    }

    public getPath(pathName: string) {
        return this._pathMap.get(pathName);
    }

    public getSpeed(speedName: string) {
        return this._speedMap.get(speedName);
    }

    public loadPath(assets: JsonAsset[], prefix: string = '') {
        assets.forEach((path) => {
            if (!path) {
                return;
            }
            if (path.json instanceof Array) {
                path.json.forEach((data) => {
                    this.loadSinglePath(data, prefix);
                });
            } else {
                const data = path.json as PathDataType;
                this.loadSinglePath(data, prefix);
            }
        });
    }

    public loadSinglePath(data: PathDataType, prefix: string = '', persist: boolean = true) {
        const pathName = `${prefix}${data.name}`;
        const exist = this.getPath(pathName);
        if (exist) {
            return exist;
        }
        data.name = pathName;
        const pathData = PathData.import(data, this._game);
        if (persist) {
            this._pathMap.set(pathName, pathData);
        }
        return pathData;
    }

    public loadSpeed(assets: JsonAsset[], prefix: string = '') {
        assets.forEach((path) => {
            if (!path) {
                return;
            }
            if (path.json instanceof Array) {
                path.json.forEach((data) => {
                    this.loadSingleSpeed(data, prefix);
                });
            } else {
                const data = path.json as SpeedCurveDataType;
                this.loadSingleSpeed(data, prefix);
            }
        });
    }

    public loadSingleSpeed(data: SpeedCurveDataType, prefix: string = '', override: boolean = false) {
        const speedName = `${prefix}${data.name}`;
        const exist = this.getSpeed(speedName);
        if (exist && !override) {
            return exist;
        }
        data.name = speedName;
        const pathData = PathData.import(data, this._game);
        this._speedMap.set(speedName, pathData);
        return pathData;
    }
}
